import React, { Fragment } from 'react';
import { Reorder } from 'framer-motion';
import { PDFImageProps } from '../../../utils/models';

import AccordionItem from '../custom-visual-inspection/accordion-item';
import CustomNewItem from '../custom-general/custom-new-item';
import LRUTDataItemForm from '../../forms/lrut/lrutDataItemForm';
import ReorderItem from '../../common/reorderItem';


export interface LRUTDataItem {
    id: number;
    shotNumber: string;
    feature: string;
    location: string;
    ecl: string;
    length: number;
    extent: number;
    class: string;
    scanDirection: string;
    notes: string;
    aScan: PDFImageProps[],
    cScan: PDFImageProps[],
}

interface Props {
    dataItems: LRUTDataItem[];
	onDataChange: (items: LRUTDataItem[]) => void;
}

const LRUTDataItems: React.FC<Props> = (props) => {
	const handleAddItem = (item: LRUTDataItem) => {
        const newItem = { ...item, id: props.dataItems.length + 1 };
		props.onDataChange([...props.dataItems, newItem]);
	};

	const handleDeleteItem = (item: LRUTDataItem): void => {
		const newAnomalyItems = props.dataItems.filter((pautItem) => pautItem.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (originalItem: LRUTDataItem, updatedItem: LRUTDataItem): void => {
        const updatedItems = props.dataItems.map((item) => item.id === originalItem.id ? updatedItem : item);
		props.onDataChange(updatedItems);
	};

	return (
		<Fragment>
            <CustomNewItem label='Add New LRUT Scan Data'>
                <LRUTDataItemForm onSave={handleAddItem} />
            </CustomNewItem>

			<div className="divider my-4"></div>

            <Reorder.Group className='list-unstyled' values={props.dataItems} onReorder={props.onDataChange}>
                {props.dataItems.map((item) => (
                    <ReorderItem key={item.id} value={item}>
                        <AccordionItem key={item.id} title={item.shotNumber} isActive isOpenOnDefault={false}>
                            <LRUTDataItemForm
                                initialLRUTItem={item}
                                onDeleteItem={() => handleDeleteItem(item)}
                                onSave={(updatedItem: LRUTDataItem) => handleEditItem(item, updatedItem)} 
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
		</Fragment>
	);
};

export default LRUTDataItems;